class PqpFaqPage {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-pqp-faq-search-form]');
    this.input = root.querySelector('[data-pqp-faq-search]');
    this.select = root.querySelector('[data-pqp-faq-select]');
    this.links = Array.from(root.querySelectorAll('[data-pqp-faq-category]'));
    this.groups = Array.from(root.querySelectorAll('[data-pqp-faq-group]'));
    this.items = Array.from(root.querySelectorAll('[data-pqp-faq-item]'));
    this.status = root.querySelector('[data-pqp-faq-status]');
    this.empty = root.querySelector('[data-pqp-faq-empty]');
    this.activeCategory = this.resolveInitialCategory();
    this.inputTimer = null;
  }

  resolveInitialCategory() {
    const hash = window.location.hash.replace('#', '');
    const matchingGroup = this.groups.find((group) => group.id === hash);
    return matchingGroup?.dataset.pqpFaqGroup || 'orders';
  }

  init() {
    this.root.classList.add('is-enhanced');

    this.links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.activeCategory = link.dataset.pqpFaqCategory;
        this.input.value = '';
        this.applyFilters();
        this.focusCategoryHeading();
      });
    });

    this.select?.addEventListener('change', () => {
      this.activeCategory = this.select.value;
      this.input.value = '';
      this.applyFilters();
      this.focusCategoryHeading();
    });

    this.form?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.applyFilters();
    });

    this.input?.addEventListener('input', () => {
      window.clearTimeout(this.inputTimer);
      this.inputTimer = window.setTimeout(() => this.applyFilters(), 120);
    });

    this.input?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.input.value) {
        this.input.value = '';
        this.applyFilters();
      }
    });

    this.items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        this.items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });

    this.applyFilters();
  }

  focusCategoryHeading() {
    const group = this.groups.find((item) => item.dataset.pqpFaqGroup === this.activeCategory);
    const heading = group?.querySelector('h2');
    if (!heading) return;
    heading.setAttribute('tabindex', '-1');
    heading.focus({ preventScroll: true });
    window.setTimeout(() => heading.removeAttribute('tabindex'), 0);
  }

  applyFilters() {
    const query = this.input?.value.trim().toLocaleLowerCase() || '';
    let visibleCount = 0;

    this.groups.forEach((group) => {
      const groupItems = Array.from(group.querySelectorAll('[data-pqp-faq-item]'));
      let groupVisibleCount = 0;

      groupItems.forEach((item) => {
        const matchesQuery = !query || item.textContent.toLocaleLowerCase().includes(query);
        const matchesCategory = query || item.dataset.category === this.activeCategory;
        const visible = Boolean(matchesQuery && matchesCategory);
        item.hidden = !visible;
        if (!visible) item.open = false;
        if (visible) {
          groupVisibleCount += 1;
          visibleCount += 1;
        }
      });

      group.hidden = groupVisibleCount === 0;
    });

    this.links.forEach((link) => {
      const isActive = !query && link.dataset.pqpFaqCategory === this.activeCategory;
      link.classList.toggle('is-active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });

    if (this.select) this.select.value = this.activeCategory;
    if (this.empty) this.empty.hidden = visibleCount !== 0;

    if (this.status) {
      const label = visibleCount === 1 ? this.root.dataset.resultSingular : this.root.dataset.resultPlural;
      this.status.textContent = `${visibleCount} ${label}.`;
    }
  }
}

document.querySelectorAll('[data-pqp-faq-root]').forEach((root) => {
  new PqpFaqPage(root).init();
});
